import Autocomplete from "@mui/material/Autocomplete";
import React from "react";
import { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { TextField } from "@mui/material";
// import Autocomplete from "@material-ui/lab/Autocomplete";
import "./testPage.css";
// import { Checkbox, FormControlLabel, MenuItem, Radio, RadioGroup, Select } from '@mui/material';
const leads = [
  { name: "ali" },
  { name: "khan" },
  { name: "asad" },
  { name: "muneeb" },
  { name: "ilyas" },
  { name: "saad" },
  { name: "usama" },
  { name: "mehran" },
  { name: "rashid" },
  { name: "khalid" },
];
const TestPage = () => {
  const { handleSubmit, reset, setValue, control } = useForm({});
  const [data, setData] = useState(null);
  return (
    <div className="global-body-container">
      <form>
        {/* <AutoComplete/> */}

        <section>
          <label>TextField</label>
          <Controller
            render={({ field }) => (
              <Autocomplete
                {...field}
                id="tags-outlined"
                options={leads}
                //   disabled={DisableLeadForm}
                defaultValue={leads[0]}
                getOptionLabel={(option) => option.name}
                // onChange={(event, value, reason, details) =>
                //   setValue("lead", value.id)
                // }
                renderOption={(props, option) => (
                  <div {...props}>{option.name}</div>
                )}
                renderInput={(params) => {
                  return (
                    <TextField
                      //   defaultValue={leads[0].name}
                      {...params}
                      type={"text"}
                      placeholder="Search Client"
                    />
                  );
                }}
              />
            )}
            name="TextField"
            control={control}
          />
        </section>
      </form>
    </div>
  );
};

export default TestPage;
